export type Plan = {
  readonly activeVersion: number;
  readonly commercial: string;
  readonly description: string;
  readonly draft?: {
    readonly unsavedChanges: number;
    readonly version: number;
  };
  readonly id: "enterprise" | "go" | "growth" | "scale";
  readonly name: "Enterprise" | "Go" | "Growth" | "Scale";
  readonly price: string;
  readonly priceLabel: string;
  readonly publishedAt: string;
  readonly publishedBy: string;
  readonly status: "active";
  readonly stripeProductId: string;
  readonly tenantsCount: number;
};

export type PlanChange = {
  readonly action: string;
  readonly date: string;
  readonly id: number;
  readonly initials: string;
  readonly reason: string;
  readonly target: string;
  readonly who: string;
};

export const plans: readonly Plan[] = [
  {
    activeVersion: 2,
    commercial:
      "Get started fast. Jobs, customers, scheduling - the essentials.",
    description: "Entry tier for solo operators - 1-3 users",
    id: "go",
    name: "Go",
    price: "$49",
    priceLabel: "$49 /mo",
    publishedAt: "Mar 8, 2026",
    publishedBy: "Olivia Sanchez",
    status: "active",
    stripeProductId: "prod_NkRGo49",
    tenantsCount: 18,
  },
  {
    activeVersion: 3,
    commercial:
      "Everything you need to scale your service business. Customers, jobs, scheduling, and forms - all in one place.",
    description:
      "Mid-tier SaaS for service companies with 5-25 users - HVAC and Pest Control verticals - Forms Library plus Customer extended.",
    draft: {
      unsavedChanges: 5,
      version: 4,
    },
    id: "growth",
    name: "Growth",
    price: "$149",
    priceLabel: "$149 /mo",
    publishedAt: "Mar 12, 2026",
    publishedBy: "Ethan Reyes",
    status: "active",
    stripeProductId: "prod_NkR8h2FxA4L9",
    tenantsCount: 42,
  },
  {
    activeVersion: 2,
    commercial:
      "Built for growth. Manage inventory, run preventive campaigns, and track the full lifecycle.",
    description:
      "Advanced tier for established companies - 25-100 users - Inventory, Maintenance, and Projects",
    id: "scale",
    name: "Scale",
    price: "$299",
    priceLabel: "$299 /mo",
    publishedAt: "Feb 22, 2026",
    publishedBy: "Olivia Sanchez",
    status: "active",
    stripeProductId: "prod_NkRScale",
    tenantsCount: 21,
  },
  {
    activeVersion: 1,
    commercial:
      "Tailored to your operation. Full builder access, custom verticals, and dedicated support.",
    description:
      "Custom contracts - large operators - Telco - 100+ users - Full builder access",
    id: "enterprise",
    name: "Enterprise",
    price: "Contact",
    priceLabel: "Contact",
    publishedAt: "Jan 15, 2026",
    publishedBy: "Ethan Reyes",
    status: "active",
    stripeProductId: "prod_NkREnt",
    tenantsCount: 6,
  },
] as const;

export const planChanges: readonly PlanChange[] = [
  {
    action: "published Growth Plan v3",
    date: "3d ago",
    id: 1,
    initials: "ER",
    reason:
      "Q2 commercial repositioning - 18 tenants impacted - enable Forms Library for all",
    target: "Growth Plan",
    who: "Ethan Reyes",
  },
  {
    action: "updated Scale Plan v2",
    date: "8d ago",
    id: 2,
    initials: "OS",
    reason: "Inventory Check toggle enabled",
    target: "Scale Plan",
    who: "Olivia Sanchez",
  },
  {
    action: "published Go Plan v2",
    date: "Mar 8",
    id: 3,
    initials: "OS",
    reason: "Entry tier pricing and onboarding defaults",
    target: "Go Plan",
    who: "Olivia Sanchez",
  },
  {
    action: "published Enterprise Plan v1",
    date: "Jan 15",
    id: 4,
    initials: "ER",
    reason: "Enterprise contracts, builder access, and support defaults",
    target: "Enterprise Plan",
    who: "Ethan Reyes",
  },
];
